import {
  getEnhancedBetslipSetting,
  isHapticFeedbackSettingEnabled,
} from '@core/Areas/Settings/Store/selectors'
import type { ClosestVenue } from '@core/Areas/VenueMode/Utils/geoFenceUtils'
import type { RootState } from '@core/Store'
import { deepMerge } from '@core/Utils/object/deepMerge'
import * as dataLayer from '../dataLayer'
import type { AnalyticsDataLayer, StructuredSearchData } from '../dataLayer/types'

export async function updateUserSettingsOnDataLayer(appState: RootState) {
  const isEnhancedBetslipEnabled = getEnhancedBetslipSetting(appState)
  const isHapticsEnabled = isHapticFeedbackSettingEnabled(appState)
  updateDataLayer({ user: { isHapticsEnabled, isEnhancedBetslipEnabled } })
}

export function updateUserBiometricsOnDataLayer(isEnabled: boolean) {
  updateDataLayer({ user: { isBiometricsEnabled: isEnabled } })
}

export function updateAccountNumberOnDataLayer(accountNumber: string | null) {
  updateDataLayer({ user: { accountNumber: accountNumber || '' } })
}

export function updateStructuredSearchOnDataLayer(structuredSearch: StructuredSearchData) {
  dataLayer.data.structuredSearch = { ...dataLayer.data.structuredSearch, ...structuredSearch }
}

export function updateUserInVenueOnDataLayer(closestVenue: ClosestVenue) {
  dataLayer.data.agency = closestVenue.inside
    ? {
        name: closestVenue.name,
        openingType: closestVenue.openingType,
        locationId: `${closestVenue.locationId}`,
        latitude: closestVenue.latitude,
        longitude: closestVenue.longitude,
        serviceType: closestVenue.serviceType,
      }
    : undefined
}

export function updateGiddyUpViewedOnDataLayer() {
  updateDataLayer({ giddyUp: { giddyUpViewed: true } })
}

export function updateGiddyUpQuaddieValueSelectedOnDataLayer(value: boolean): void {
  updateDataLayer({ giddyUp: { quaddieValueSelected: value } })
}

export function updateGiddyUpTabOnDataLayer(tab: string): void {
  updateDataLayer({ giddyUp: { selectedTab: tab } })
}

export function updateBettingPropertiesOnDataLayer(
  data: DeepPartial<Pick<AnalyticsDataLayer, 'bet' | 'quickbet' | 'user'>>
) {
  updateDataLayer(data)
}

// =============
// Local Helpers
// =============

function updateDataLayer(data?: DeepPartial<AnalyticsDataLayer>): void {
  if (!data) return

  // Make sure we were sent something that can be merged
  deepMerge(dataLayer.data, data)
}

// =====
// Types
// =====

type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}
